const ErrorLayer = ({ error }) => {
  if (!error || !error.message) return null
  return <span className="error-message">{error.message}</span>
}
export default ErrorLayer
